module.exports = __webpack_public_path__ + "img/clear-dark.0c1a81ac.png";